import { ICart } from '../models/ICart'
import { IAllowedPartKeyValue } from '../store/hooks/useAllowedPartsFlag'
import findDeliveryDateForInstallAtShop from './findDeliveryDateForInstallAtShop'
import getIsCartItemAvailableForDifm from './getIsCartItemAvailableForDifm'

const getLastSkuETAForDifm = (cartData: ICart, onlyFromAddedShop = false, allowedPartsForDifmMasterFilter?: IAllowedPartKeyValue) => {
  if (!cartData || !cartData.items?.length) {
    return null
  }

  const itemsAvailableForDifm = cartData.items.filter(c => getIsCartItemAvailableForDifm(c, allowedPartsForDifmMasterFilter))
  const allSkuEtaDates = itemsAvailableForDifm
    .filter(item => !onlyFromAddedShop || Boolean(item.modifiers?.difm))
    .map(item => findDeliveryDateForInstallAtShop(item?.shippingOption?.options || [], 'deliveryDate'))
    .filter(etaValue => Boolean(etaValue))
    .map(etaValue => new Date(etaValue as string))
    .sort((a, b) => b.getTime() - a.getTime())

  return allSkuEtaDates.length > 0 ? allSkuEtaDates[0].toJSON() : ''
}

export default getLastSkuETAForDifm
